import React, { useState, useEffect } from 'react';
import getPrognosisLogs from '@api/patient-notes';
import { PrognosisData } from '@typings/Patients';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import Pagination from '@components/pagination';
import { ApiResponse, ListApiResponse } from '@typings/ApiResponse';

dayjs.extend(advancedFormat);

interface PrognosisTableProps {
  slug: string;
  isUpdatedPronosis: boolean;
}

const PrognosisTable: React.FC<PrognosisTableProps> = ({
  slug,
  isUpdatedPronosis,
}) => {
  const [prognosisLog, setPrognosisLog] = useState<PrognosisData[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  useEffect(() => {
    const handleGetPrognosisLogs = async () => {
      try {
        const response: ApiResponse<ListApiResponse<PrognosisData>> =
          await getPrognosisLogs(slug, currentPage, 5);
        if (response && response.status === 'success') {
          setPrognosisLog(response?.data?.data);
          setTotalPages(response?.data?.pages);
        }
      } catch (error) {
        console.error(error);
      }
    };

    if (slug) {
      handleGetPrognosisLogs();
    }
  }, [slug, currentPage, isUpdatedPronosis]);

  useEffect(() => {
    setCurrentPage(1);
  }, [isUpdatedPronosis]);

  return (
    <div className="mt-10 govuk-bp:mt-14">
      <table className="govuk-table govuk-table--small-text-until-tablet">
        <thead className="govuk-table__head">
          <tr className="govuk-table__row">
            <th scope="col" className="govuk-table__header">
              Level of need (PIG)
            </th>
            <th scope="col" className="govuk-table__header">
              Date of Prognosis
            </th>
            <th scope="col" className="govuk-table__header">
              Performing professional
            </th>
          </tr>
        </thead>
        <tbody className="govuk-table__body">
          {prognosisLog?.map(prog => {
            return (
              <tr key={prog.updatedAt} className="govuk-table__row">
                <td className="govuk-table__cell">{prog.prognosis}</td>
                <td className="govuk-table__cell">
                  {prog.updatedAt
                    ? dayjs(prog.updatedAt).format('Do MMMM')
                    : ''}
                </td>
                <td className="govuk-table__cell">{prog.user.full_name}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <Pagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
      />
    </div>
  );
};

export default PrognosisTable;
